import PropTypes from 'prop-types';
import useWindowDimensions from 'hooks/use-window-dimensions';
import { Loading } from 'components/UI/Loading/Loading';
import { EventTileGroupCarousel } from './EventTileGroupCarousel';
import { EventTileGroupStandard } from './EventTileGroupStandard';

import './EventTileGroup.scss';

export const EventTileGroup = (props) => {
  const { children, isLoading, hasFeaturedTile, collapseOnMobile = false } = props;

  const { isMobile } = useWindowDimensions();
  const classes = `event-tile-group row is-flex ${hasFeaturedTile ? 'has-featured-tile' : ''}`;

  const groupType =
    isMobile && !collapseOnMobile ? (
      <EventTileGroupCarousel>{children}</EventTileGroupCarousel>
    ) : (
      <EventTileGroupStandard>{children}</EventTileGroupStandard>
    );

  return (
    <div className={classes} data-testid="event-tile-group">
      {isLoading ? <Loading /> : groupType}
    </div>
  );
};

EventTileGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isLoading: PropTypes.bool,
  hasFeaturedTile: PropTypes.bool,
  collapseOnMobile: PropTypes.bool,
};
